<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid class="px-6 py-0">
      <div class="d-flex">
        <h2>{{ $t('dueDiligence.dueDiligenceReportCreation') }}</h2>
        <v-spacer></v-spacer>
      </div>

      <v-card elevation="0" class="px-5 mt-7">
        <v-card-text>
          <v-row style="margin-left:-30px; margin-bottom: 20px; margin-top: 15px;">
            <v-col v-if="allowCreateEditDdsReport" cols="12" sm="6" md="4" lg="3">
              <v-card @click="redirectToCreateDueDiligence"
                class="mx-auto rounded-lg d-flex flex-column align-center justify-center dashboard-card"
                style="cursor: pointer;">
                <v-img max-height="100" max-width="95" :src="isIndonesianClient ? '/img/id/edit.svg' : isKenyaClient ? '/img/ke/edit.svg' : '/img/edit.png'" class="img-center mb-3"></v-img>
                <span class="card-title text-center">{{ $t('dueDiligence.createNewDueDiligenceProgress') }}</span>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-card @click="redirectTodueDiligenceReports"
                class="mx-auto rounded-lg d-flex flex-column align-center justify-center dashboard-card"
                style="cursor: pointer;">
                <v-img max-height="100" max-width="95" :src="isIndonesianClient ? '/img/id/lists.svg' : isKenyaClient ? '/img/ke/lists.svg' : '/img/list.png'" class="img-center mb-3"></v-img>
                <span class="card-title text-center">{{ $t('dueDiligence.dueDiligenceReports') }}</span>
              </v-card>
            </v-col>
            <v-col v-if="allowCreateEditDdsReport" cols="12" sm="6" md="4" lg="3">
              <v-card @click="redirectToSettings" class="mx-auto rounded-lg d-flex flex-column align-center justify-center dashboard-card"
                style="cursor: pointer;">
                <v-img max-height="100" max-width="95" :src="isIndonesianClient ? '/img/id/settings.svg' : isKenyaClient ? '/img/ke/settings.svg' : '/img/setting.png'" class="img-center mb-3"></v-img>
                <span class="card-title text-center">{{ $t('deforestation.settings') }}</span>
              </v-card>
            </v-col>

            <v-col v-if="isSupplier" cols="12" sm="6" md="4" lg="3">
              <v-card @click="redirectToMyFarms" class="mx-auto rounded-lg d-flex flex-column align-center justify-center dashboard-card"
                style="cursor: pointer;">
                <v-img max-height="100" max-width="95" :src="isIndonesianClient ? '/img/farm-indonesia.png' : isKenyaClient ? '/img/ke/farm.png' : '/img/farm.png'" class="img-center mb-3"></v-img>
                <span class="card-title text-center">{{ $t('dueDiligence.myFarms') }}</span>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" v-if="isSupplier">
              <v-card @click="redirectToProducer" class="mx-auto rounded-lg d-flex flex-column align-center justify-center dashboard-card"
                style="cursor: pointer;">
                <v-img max-height="100" max-width="95" :src="isIndonesianClient ? '/img/list-indonesia.png' : isKenyaClient ? '/img/ke/list.png' :  '/img/list.png'" class="img-center mb-3"></v-img>
                <span class="card-title text-center">{{ $t('dueDiligence.listOfProducers') }}</span>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="!isOperator && !isSupplier">
              <div class="d-flex" style="margin-top: 60px;">
              <p class="heading-title">
                {{ $t('dueDiligence.dueDiligenceReports') }}
                <v-tooltip top color="00BD73" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>{{ $t('dueDiligence.dueDiligenceReportsInfo') }}</span>
                </v-tooltip>
              </p>
              <v-spacer></v-spacer>
            </div>

            <!-- Mobile card view for Due Diligence Reports -->
            <div v-if="$vuetify && $vuetify.breakpoint.smAndDown">
              <!-- Mobile Controls Bar -->
              <div class="mobile-controls-bar mb-4">
                <div class="mobile-controls-left">
                  <v-text-field 
                    prepend-inner-icon="mdi-magnify" 
                    outlined 
                    dense
                    :placeholder="$t('search')" 
                    v-model="reportSearch" 
                    @input="searchQuery" 
                    class="mobile-search"
                  />
                  <v-select 
                    :items="countries"
                    v-model="reportCountry" 
                    item-text="name"
                    item-value="name" 
                    :label="$t('deforestation.allCountries')"
                    @change="getDeforestationEUDR" 
                    outlined 
                    dense
                    class="mobile-filter"
                  />
                  <v-select 
                    v-model="reportStatus" 
                    item-text="text"
                    item-value="val" 
                    :items="allStatus" 
                    :label="$t('deforestation.edurDueDeligenceStatus')" 
                    @change="getDeforestationEUDR"
                    outlined 
                    dense
                    class="mobile-filter"
                  />
                </div>
              </div>

              <!-- Mobile Cards -->
              <v-row>
                <v-col cols="12" v-for="item in diligenceReports" :key="item.id">
                  <v-card class="mb-3 pa-4 report-card">
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="report-title">
                        <span class="font-weight-bold" style="font-size: 1.2rem;">Internal Reference #:</span>
                        <span class="font-weight-bold" style="font-size: 1.2rem;">{{ item.internalReferenceNumber }}</span>
                      </div>
                      <v-menu v-if="!isDdsExporterLockedOutForItem(item)" location="end">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-if="!isDdsExporter" @click="navigateReportView(item)">
                            <v-list-item-title>{{ $t('dueDiligence.viewReport') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="needsPaymentResponse(item)" @click="openPaymentResponsibilityModal(item)">
                            <v-list-item-title>{{ $t('dueDiligence.paymentResponsibilityTitle') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="canReportPayment(item)" @click="openReportPaymentModal(item)">
                            <v-list-item-title>{{ $t('dueDiligence.reportPayment') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="canReleasePaymentResponsibility(item)" @click="confirmReleasePaymentResponsibility(item)">
                            <v-list-item-title>{{ $t('dueDiligence.releasePaymentResponsibility') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="canVerifyPayment(item)" @click="openVerifyPaymentModal(item)">
                            <v-list-item-title>{{ $t('dueDiligence.verifyPayment') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="canViewInvoice(item)" @click="openViewInvoiceModal(item)">
                            <v-list-item-title>{{ invoiceMenuLabel(item) }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                    <v-divider class="mb-2"/>
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">EUDR Reference #:</span>
                      <span>{{ item.EUDRReferenceNumber  || 'N/A' }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">Supplier:</span>
                      <span>{{ getSupplierFullName(item) }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">Product:</span>
                      <span>{{ item.product_detail ? (item.product_detail.code ? item.product_detail.code + '-' : '') : '' }}{{ item.product_detail ? item.product_detail.name : '' }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">Farms:</span>
                      <span>{{ item.productionPlaceCount }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">Quantity:</span>
                      <span>{{ !isNaN(item.productNetMass) ? parseFloat(getConvertedMass(item.productNetMass)) : 0 }} {{ eudrSettings?.product_mass_unit }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">Country:</span>
                      <span>{{ item.countryOfEntry }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-1 report-row">
                      <span class="font-weight-medium">Last Updated:</span>
                      <span>{{ formatDate(item.updatedAt) }}</span>
                    </div>
                    <v-divider class="my-1" />
                    <div class="d-flex align-center justify-space-between py-2 report-row">
                      <span class="font-weight-medium">Due Diligence Status:</span>
                      <template v-if="isDdsExporterLockedOutForItem(item)">
                        <PaymentUnavailableStatus />
                      </template>
                      <template v-else>
                      <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                        v-if="item.status == 'Uploaded to EU Portal'">
                        <!-- getModulePermittedActions.put -->
                        {{ $t("deforestation.uploadedToEU") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="gray-button" height="34"
                        v-if="item.status == 'Pending' && !hasActivePaymentStatusLegend(item)">
                        {{ $t("deforestation.pending") }}
                      </v-btn>
                      <v-btn small rounded min-width="160" depressed class="orange-button" height="34"
                        v-if="item.status == 'Under Review' && !hasActivePaymentStatusLegend(item)">
                        {{ $t("deforestation.underReview") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="orange-button" height="34"
                        v-if="isWaitingForPaymentStatus(item)">
                        {{ $t("deforestation.waitingForPayment") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                        v-if="isPaymentPendingVerificationStatus(item)">
                        {{ $t("deforestation.paymentPendingVerificationStatus") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                        v-if="isPendingApprovalStatus(item)">
                        {{ $t("deforestation.pendingApproval") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="green-button" height="34"
                        v-if="isDdsCompliantStatus(item.status) && !isPendingApprovalStatus(item) && !isWaitingForPaymentStatus(item) && !isPaymentPendingVerificationStatus(item)">
                        {{ $t("deforestation.compliant") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="orange-button" height="34"
                        v-if="item.status.toLowerCase() == 'processing farms' && !hasActivePaymentStatusLegend(item)">
                        {{ $t("deforestation.processingFarm") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="gray-button" height="34"
                        v-if="item.status.toLowerCase() == 'analyzing deforestation' && !hasActivePaymentStatusLegend(item)">
                        {{ $t("deforestation.analyzeDeforestation") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                        v-if="item.status.toLowerCase() == 'ready to proceed' && !hasActivePaymentStatusLegend(item)">
                        {{ $t("deforestation.readyToProceed") }}
                      </v-btn>


                      <v-btn small rounded min-width="160" depressed class="red-button" height="34"
                        v-if="isDdsNonCompliantStatus(item.status) && !isPendingApprovalStatus(item) && !isWaitingForPaymentStatus(item) && !isPaymentPendingVerificationStatus(item)">
                        {{ $t("deforestation.nonCompliant") }}
                      </v-btn>

                      <v-btn small rounded min-width="160" depressed class="green-button" height="34"
                        v-if="item.status == 'Mitigation Required' && !hasActivePaymentStatusLegend(item)">
                        {{ $t("deforestation.mitigationRequired") }}
                      </v-btn>
                      </template>
                    </div>
                    <template v-if="isPtsiApprovalClient">
                      <v-divider class="my-1" />
                      <div class="d-flex align-center justify-space-between py-2 report-row">
                        <span class="font-weight-medium">{{ $t('deforestation.riskStatus') }}:</span>
                        <span v-if="isDdsExporterLockedOutForItem(item)">N/A</span>
                        <v-btn v-else-if="getRiskStatusMeta(item)" small rounded depressed
                          :class="getRiskStatusMeta(item).badgeClass" height="28" style="min-width:130px;">
                          {{ getRiskStatusMeta(item).label }}
                        </v-btn>
                        <span v-else>-</span>
                      </div>
                    </template>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Mobile Pagination -->
              <div class="mobile-pagination mt-4">
                <div class="d-flex justify-space-between align-center">
                  <span class="mobile-pagination-label">{{ toDiligenceReports }} of {{ totalDiligenceReports }}</span>
                  <div class="mobile-pagination-controls">
                    <v-btn 
                      fab 
                      small 
                      outlined 
                      color="primary" 
                      :disabled="reportOptions.page <= 1"
                      @click="reportPageChange(false)"
                      class="mr-2"
                    >
                      <v-icon dark>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn 
                      fab 
                      small 
                      outlined 
                      color="primary" 
                      :disabled="reportOptions.page >= reportTotalPages"
                      @click="reportPageChange(true)"
                    >
                      <v-icon dark>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <v-data-table v-else :headers="tableHeaders" :items="diligenceReports" :items-per-page="10" hide-default-footer
              :loading="loading" :options="reportOptions" @update:options="onReportOptionsUpdate" :server-items-length="totalDiligenceReports" :loading-text="$t('loadingData')">

              <template v-slot:top="{ }">
                <div class="table-controls-bar">
                  <div class="controls-left">
                    <div class="control search">
                      <label>{{ $t('search') }}</label>
                      <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        dense
                        :placeholder="$t('search')"
                        v-model="reportSearch"
                        @input="searchQuery"
                      />
                    </div>
                    <div class="control filter">
                      <label>{{ $t('country') }}  <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="16" class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                            </v-icon>
                          </template>
                          <span>{{ $t("deforestation.EUDRcountry") }}</span>
                        </v-tooltip></label>
                      <v-select
                        :items="countries"
                        v-model="reportCountry"
                        item-text="name"
                        item-value="name"
                        dense
                        outlined
                        :placeholder="$t('deforestation.allCountries')"
                        @change="getDeforestationEUDR"
                      />
                    </div>
                    <div class="control filter">
                      <label>{{ $t('deforestation.edurDueDeligenceStatus') }}  <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="16" class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                            </v-icon>
                          </template>
                          <span>{{ $t("deforestation.EUDRDeforestationStatusTT") }}</span>
                        </v-tooltip></label>
                      <v-select
                        v-model="reportStatus"
                        item-text="text"
                        item-value="val"
                        :items="allStatus"
                        @change="getDeforestationEUDR"
                        outlined
                        dense
                      />
                    </div>
                    <!-- <div class="control download-history">
                      <p class="text-decoration-underline cursor-pointer primary--text mb-0" @click="showAllDownloads">
                        {{ $t('dueDiligence.viewDownloadHistory') }}
                      </p> -->
                    <!-- </div> -->
                  </div>
                  <div class="controls-right">
                    <span class="pagination-label">{{ toDiligenceReports }} of {{ totalDiligenceReports }}</span>
                    <v-btn fab small outlined color="primary" :disabled="reportOptions.page <= 1" @click="reportPageChange(false)">
                      <v-icon dark>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn fab small outlined color="primary" :disabled="reportOptions.page >= reportTotalPages" @click="reportPageChange(true)">
                      <v-icon dark>mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn fab small outlined color="primary" v-bind="attrs" v-on="on">
                                <v-icon dark>mdi-cog-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-card width="417">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ $t("deforestation.customization") }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <div class="pl-3 pt-2 font-weight-normal">
                                    {{ $t("deforestation.recordsPerpage") }}
                                </div>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions" :max="3" step="1" ticks="always" tick-size="4"></v-slider>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-n3"></v-divider>
                            </v-list>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col class="mt-n9" cols="6" v-for="header in visibleReportHeaders" :key="header.value">
                                            <v-checkbox v-if="header.text" v-model="selectedHeaders" :label="header.text" color="primary" :value="header.text" hide-details></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-layout justify-center>
                                <v-card-actions class="mb-5">
                                    <v-spacer></v-spacer>
                                    <v-btn outlined color="primary" @click="resetDefaut" width="190">
                                        {{ $t("deforestation.restoreDefault") }}
                                    </v-btn>
                                    <v-btn color="primary" @click="resetTableStructure" width="190">
                                        {{ $t("deforestation.apply") }}
                                    </v-btn>
                                </v-card-actions>
                            </v-layout>
                        </v-card>
                    </v-menu>
                    <v-btn fab small outlined color="primary" @click="exportToPDF">
                      <v-icon dark>mdi-tray-arrow-down</v-icon>
                    </v-btn>
                    <v-btn fab small outlined color="primary" @click="printPDF('document')">
                      <v-icon dark>mdi-printer</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>

              <template v-slot:item.EUDRReferenceNumber="{ item }">
                {{ item.EUDRReferenceNumber + item.EUDRReferenceNumber?'-' + item.internalReferenceNumber: item.internalReferenceNumber }}
              </template>

              <template v-slot:item.supplier="{ item }">
                {{ getSupplierFullName(item) }}
              </template>

              <template v-slot:item.product="{ item }">
                {{ item.product_detail ? (item.product_detail.code ? item.product_detail.code +'-' : "") : '' }}
                {{ item.product_detail  ? item.product_detail.name  : '' }}
              </template>

              <template v-slot:item.productNetMass="{ item }">
                {{ item.productionPlaceCount }} <br />
                {{ !isNaN(item.productNetMass) ? parseFloat(getConvertedMass(item.productNetMass)) : 0 }} {{ eudrSettings?.product_mass_unit }}
              </template>

              <template v-slot:item.countryOfEntry="{ item }">
                {{ item.countryOfEntry }}
              </template>

              <template v-slot:item.createdAt="{ item }">
                {{ formatDate(item.createdAt) }}
              </template>

              <template v-slot:item.updatedAt="{ item }">
                {{ formatDate(item.updatedAt) }}
              </template>

              <template v-slot:item.riskStatus="{ item }">
                <span v-if="isDdsExporterLockedOutForItem(item)">N/A</span>
                <v-btn v-else-if="getRiskStatusMeta(item)" small rounded min-width="150" depressed
                  :class="getRiskStatusMeta(item).badgeClass" height="30">
                  {{ getRiskStatusMeta(item).label }}
                </v-btn>
                <span v-else>-</span>
              </template>

              <template v-slot:item.dueDeligenceStatus="{ item }">
                <div class="d-flex">
                  <PaymentUnavailableStatus v-if="isDdsExporterLockedOutForItem(item)" />
                  <div v-else class="no-pointer">
                  <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                    v-if="item.status == 'Uploaded to EU Portal'">
                    {{ $t("deforestation.uploadedToEU") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="gray-button" height="34"
                    v-if="item.status == 'Pending' && !hasActivePaymentStatusLegend(item)">
                    {{ $t("deforestation.pending") }}
                  </v-btn>
                  <v-btn small rounded min-width="160" depressed class="orange-button" height="34"
                    v-if="item.status == 'Under Review' && !hasActivePaymentStatusLegend(item)">
                    {{ $t("deforestation.underReview") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="orange-button" height="34"
                    v-if="isWaitingForPaymentStatus(item)">
                    {{ $t("deforestation.waitingForPayment") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                    v-if="isPaymentPendingVerificationStatus(item)">
                    {{ $t("deforestation.paymentPendingVerificationStatus") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                    v-if="isPendingApprovalStatus(item)">
                    {{ $t("deforestation.pendingApproval") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="green-button" height="34"
                    v-if="isDdsCompliantStatus(item.status) && !isPendingApprovalStatus(item) && !isWaitingForPaymentStatus(item) && !isPaymentPendingVerificationStatus(item)">
                    {{ $t("deforestation.compliant") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="orange-button" height="34"
                    v-if="item.status.toLowerCase() == 'processing farms' && !hasActivePaymentStatusLegend(item)">
                    {{ $t("deforestation.processingFarm") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="gray-button" height="34"
                    v-if="item.status.toLowerCase() == 'analyzing deforestation' && !hasActivePaymentStatusLegend(item)">
                    {{ $t("deforestation.analyzeDeforestation") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="blue-button" height="34"
                    v-if="item.status.toLowerCase() == 'ready to proceed' && !hasActivePaymentStatusLegend(item)">
                    {{ $t("deforestation.readyToProceed") }}
                  </v-btn>


                  <v-btn small rounded min-width="160" depressed class="red-button" height="34"
                    v-if="isDdsNonCompliantStatus(item.status) && !isPendingApprovalStatus(item) && !isWaitingForPaymentStatus(item) && !isPaymentPendingVerificationStatus(item)">
                    {{ $t("deforestation.nonCompliant") }}
                  </v-btn>

                  <v-btn small rounded min-width="160" depressed class="green-button" height="34"
                    v-if="item.status == 'Mitigation Required' && !hasActivePaymentStatusLegend(item)">
                    {{ $t("deforestation.mitigationRequired") }}
                  </v-btn>
                  </div>

                  <v-spacer></v-spacer>
                  <v-tooltip v-if="!isDdsExporterLockedOutForItem(item)" top color="00BD73" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <img v-bind="attrs" v-on="on" class="ml-1" :src="isIndonesianClient ? '/img/id/todo-list.svg' : isKenyaClient ? '/img/ke/todo-list.svg' : '/icons/todo-list.png'"
                        style="width: 34px; height: 34px; border-radius: 50%;" @click="navigateReportView(item)" />

                    </template>
                    <span>{{ $t('dueDiligence.viewReport') }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu v-if="!isDdsExporterLockedOutForItem(item)" location="start">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item v-if="!isDdsExporter" @click="navigateReportView(item)">
                      <v-list-item-title>{{ $t('dueDiligence.viewReport') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="item.status === 'Pending'" @click="
                      $router.push({
                        name: 'EudrAssessmentReport',
                        params: { id: item.id, type: 'assignment' },
                      })
                    ">
                      <v-list-item-title>{{ $t('dueDiligence.share') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="!['Compliant', 'Non-Compliant', 'Processing  Farms'].includes(item.status)"
                      @click="redirectToDDSSUmmary(item.id)">
                      <v-list-item-title>{{ $t('dueDiligence.viewReportSummary') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="needsPaymentResponse(item)" @click="openPaymentResponsibilityModal(item)">
                      <v-list-item-title>{{ $t('dueDiligence.paymentResponsibilityTitle') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canReportPayment(item)" @click="openReportPaymentModal(item)">
                      <v-list-item-title>{{ $t('dueDiligence.reportPayment') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canReleasePaymentResponsibility(item)" @click="confirmReleasePaymentResponsibility(item)">
                      <v-list-item-title>{{ $t('dueDiligence.releasePaymentResponsibility') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canVerifyPayment(item)" @click="openVerifyPaymentModal(item)">
                      <v-list-item-title>{{ $t('dueDiligence.verifyPayment') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canViewInvoice(item)" @click="openViewInvoiceModal(item)">
                      <v-list-item-title>{{ invoiceMenuLabel(item) }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      :disabled="item.status.toLowerCase().startsWith('processing') || item.status.toLowerCase().startsWith('analyzing')"
                      @click="deleteDiligenceReports(item.id)">
                      <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:footer></template>
            </v-data-table>


            <!-- Status Legend Section -->
            <div v-if="isDdsExporter || isSupplierOwner" class="status-legend-section mt-6 mb-4 pa-4">
              <div class="legend-title font-weight-bold mr-3">
                {{ $t("deforestation.statusLegend") }}
                <v-tooltip top color="00BD73" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="16" class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                      mdi-information
                    </v-icon>
                  </template>
                  <span>{{ $t("deforestation.statusLegendInfo") }}</span>
                </v-tooltip>
              </div>
              <div class="legend-item d-inline-flex align-center mr-4 mt-2">
                <span class="legend-item d-inline-flex align-center mr-4">
                <img src="/icons/dds/pending.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> <span v-if="isDdsExporter"> {{ $t("deforestation.pendingOrNewlyReceived") }} </span> <span v-else> {{ $t("deforestation.sentToExporter") }} </span>
                </span>
                <span class="legend-item d-inline-flex align-center mr-4">
                  <img src="/icons/dds/approved.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{ $t("deforestation.approved") }}
                </span>
                <span class="legend-item d-inline-flex align-center mr-4">
                  <img src="/icons/dds/updaterequired.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{ $t("deforestation.updateRequired") }}
                </span>
                <span class="legend-item d-inline-flex align-center mr-4">
                  <img src="/icons/dds/rejected.svg" style="width: 20px; height: 20px; margin-right: 5px;" /> {{ $t("deforestation.rejected") }}
                </span>
                <span v-if="isDdsExporter" class="legend-item d-inline-flex align-center mr-4">
                  <PaymentUnavailableStatus legend />
                </span>
              </div>
            </div>

            <div v-if="!isDdsExporter" class="d-flex" style="margin-top: 60px;">
              <p class="heading-title">
                {{ $t("dueDiligence.listOfFarms") }}
                <v-tooltip top color="00BD73" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>{{ $t("dueDiligence.listOfFarmsInfo") }}</span>
                </v-tooltip>
              </p>
              <v-spacer></v-spacer>
            </div>

            <v-data-table v-if="!isDdsExporter" ref="list-of-farm" :headers="placesHeaders" :items="productionPlaces" :itemsPerPage="10"
              hide-default-footer :loading="listOfFarmloading" :options.sync="options"
              :loading-text="$t('loadingData')">

              <template v-slot:top="{ }">
                <div class="d-flex mt-5">
                  <div style="width: 280px;">
                    <label for="text">
                      {{ $t("search") }}
                    </label>
                    <v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px" :placeholder="$t('search')"
                      dense v-model="placeSearch" @input="handleSearchByPharse" class="shrink" clearable></v-text-field>
                  </div>
                  <template v-if="isOperatorOwner">
                    <v-btn outlined class="mx-2 mt-5" color="grey" @click="showFilters= true"
                      style="min-width: 40px; padding: 0;">
                      <v-icon>mdi-filter-outline</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="ml-3" style="width: 280px;">
                      <label for="text">{{ $t("country") }}</label>
                      <v-select :items="countries" v-model="placeCountry" item-text="name" item-value="name" dense
                        outlined class="wdt" :placeholder="$t('deforestation.allCountries')"
                        @change="filterData"></v-select>
                    </div>

                    <div class="ml-3" style="width: 280px;">
                      <label for="text">{{ $t("deforestation.producer") }}</label>
                      <v-tooltip top color="00BD73" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>{{ $t("dueDiligence.producerTT") }}</span>
                      </v-tooltip>
                      <v-select class="wdt" v-model="producerModel" item-text="text" item-value="val"
                        :items="allProducers" :placeholder="$t('deforestation.allProducer')" @change="filterData"
                        outlined dense>
                      </v-select>
                    </div>

                    <div class="ml-3" style="width: 280px;">
                      <label for="text">{{
                        $t("deforestation.EUDRDeforestationStatus")
                        }}</label>
                      <v-tooltip top color="00BD73" max-width="350">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon class="icon-with-background primary--text" v-bind="attrs" v-on="on">
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>{{ $t("deforestation.EUDRDeforestationStatusTT") }}</span>
                      </v-tooltip>
                      <v-select class="wdt" v-model="placeStatus" item-text="text" item-value="val"
                        :items="deforestationStatus" :placeholder="$t('deforestation.EUDRDeforestationStatus')"
                        @change="filterData" outlined dense>
                      </v-select>
                    </div>

                    <v-spacer></v-spacer>
                    <div class="d-flex" style="margin-top: 15px;">
                      <div class="py-1 title">
                        {{ fromProducer }} - {{ toProducer }} {{ $t('of') }} {{ totalProductionPlaces }}
                      </div>
                      <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                        @click="pageChange(false)">
                        <v-icon dark>
                          mdi-chevron-left
                        </v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages"
                        @click="pageChange(true)">
                        <v-icon dark>
                          mdi-chevron-right
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>
                </div>
              </template>
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="index"
                    style="position: relative; width: 0; height: 0">

                    <td class="text-truncate">
                      {{ item.farm?.farmName || "N/A" }}<br />
                      {{ item.farm?.id }}
                    </td>

                    <td class="text-truncate">
                      {{ item.farm?.userDdsAssoc?.firstName }}
                      {{ item.farm?.userDdsAssoc?.lastName }}
                    </td>
                    <td class="text-truncate">
                      {{ getFarmSupplierFullName(item) }}
                    </td>
                    <td class="text-truncate" style="max-width: 300px;">
                      {{ item?.farm?.address }}
                    </td>
                    <td>
                      <v-btn v-if="getEUDRDeforestationStatus(item.eudr_deforestation_status).text !== 'N/A'" small
                        rounded min-width="200" depressed
                        :class="[getEUDRDeforestationStatus(item.eudr_deforestation_status).class, 'non-clickable']" height="34">
                        {{ getEUDRDeforestationStatus(item.eudr_deforestation_status).text }}
                      </v-btn>
                      <span v-else>N/A</span>
                    </td>
                    <td>
                      <div class="d-flex">
                        <div class="d-flex" v-if="getRiskAssessmentStatus(item.risk_assessment_status).text !== 'N/A'">
                          <v-btn small rounded min-width="200" depressed
                            :class="getRiskAssessmentStatus(item.risk_assessment_status).class" height="34">
                            {{ getRiskAssessmentStatus(item.risk_assessment_status).text }}
                          </v-btn>
                          <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <img v-bind="attrs" v-on="on" class="ml-1" src="/icons/todo-list.png"
                                style="width: 34px; height: 34px; border-radius: 50%;" />
                            </template>
                            <span>{{ $t('dueDiligence.viewReport') }}</span>
                          </v-tooltip>

                        </div>
                        <span v-else>N/A</span>
                      </div>
                    </td>
                    <td>
                      <v-tooltip top color="00BD73" max-width="350" v-if="allowCreateEditDdsReport">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" x-small fab @click="removeFarm(item.farm.id)"
                              style="margin-left: 20px;">
                              <v-icon class="primary--text">mdi-trash-can</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('delete') }}</span>
                        </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <!-- <v-row>
              <v-col cols="col-12 mx-10">
                <v-alert
                  v-if="alertData.show"
                  type="dark"
                  class="white--text sticky-bottom-alert"
                  >
                  <div class="d-flex justify-space-between align-center">
                    <span>
                      <v-icon class="mr-2" color="white">mdi-check-circle</v-icon>
                      <strong>{{$t('dueDiligence.downloadInitiated')}}:</strong> {{ alertData.downloadId}} {{ $t("dueDiligence.beingDownloaded")}}: {{ alertData.estimatedTime }}
                    </span>

                    <div class="ml-4 d-flex cursor-pointer align-center">
                      <p
                        text
                        class="text-decoration-underline mb-0"
                        color="white"
                        @click="showAllDownloads"
                      >
                        {{ $t("dueDiligence.showAllDownloads" )}}
                      </p>
                      <v-icon
                        text
                        color="white"
                        @click="closeAlert"
                      >
                        mdi-close
                      </v-icon>
                    </div>
                  </div>
                </v-alert>
              </v-col>
            </v-row> -->
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-if="isOperatorOwner" v-model="showFilters" width="356" @click:outside="closeFilter" content-class="my-custom-dialog"
      max-height="100vh" transition="dialog-bottom-transition">
      <v-card min-height="100vh" class="" rounded="0">
        <v-toolbar color="primary" class="white--text" flat :elevation="0">
          <v-toolbar-title class="font-weight-bold">{{
            this.$t("filterBy")
            }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon class="white--text" @click="closeFilter">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-row no-gutters>
            <v-col cols="12">
              <label for="text">{{
                $t("deforestation.allProducer")
                }}</label>
              <v-select v-model="producerModel" item-text="text" item-value="val" :items="allProducers"
                :placeholder="$t('deforestation.allProducer')" outlined dense>
              </v-select>

            </v-col>
            <v-col cols="12">
              <label for="text">{{
                $t("dueDiligence.listOfSupplier")
              }}</label>
              <v-autocomplete v-model="supplierModel" :items="supplierList" item-text="label" item-value="val"
                :placeholder="$t('dueDiligence.listOfSupplier')" outlined dense />

            </v-col>
            <v-col cols="12">
              <label for="text">{{
                $t("deforestation.EUDRDeforestationStatus")
                }}</label>
              <v-select v-model="placeStatus" item-text="text" item-value="val" :items="deforestationStatus"
                :placeholder="$t('deforestation.EUDRDeforestationStatus')" outlined dense>
              </v-select>
            </v-col>

            <v-col cols="12">
              <label for="text">{{ $t("country") }}</label>
              <v-select :items="countries" v-model="placeCountry" item-text="name" item-value="name" dense outlined
                :placeholder="$t('deforestation.allCountries')"></v-select>
            </v-col>


          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn outlined @click="clearFilters" width="130" color="primary">
                {{ this.$t("clearAll") }}
              </v-btn>
              <v-btn width="130" @click="getProductionPlaces" color="primary">
                {{ this.$t("search") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-box :title="confirmDelete.title" :message="confirmDelete.message"
      :cancelBtnText="confirmDelete.cancelBtnText" :confirmBtnText="confirmDelete.confirmBtnText"
      :confirmData="confirmDelete.confirmData" :dialog="confirmDeleteDialog"
      @cancel:action="confirmDeleteDialog = false" @continue:action="confirmDeleteDiligenceReport" />
    <confirm-box :title="farmConfirmDelete.title" :message="farmConfirmDelete.message"
      :cancelBtnText="farmConfirmDelete.cancelBtnText" :confirmBtnText="farmConfirmDelete.confirmBtnText"
      :confirmData="farmConfirmDelete.confirmData" :dialog="farmConfirmDeleteDialog"
      @cancel:action="farmConfirmDeleteDialog = false" @continue:action="confirmRemoveFarm" />
    <confirm-box :title="releasePaymentConfirm.title" :message="releasePaymentConfirm.message"
      :cancelBtnText="releasePaymentConfirm.cancelBtnText" :confirmBtnText="releasePaymentConfirm.confirmBtnText"
      :confirmData="releasePaymentConfirm.confirmData" :dialog="releasePaymentConfirmDialog"
      :loading="releasePaymentConfirmLoading"
      @cancel:action="closeReleasePaymentConfirm" @continue:action="handleReleasePaymentResponsibility" />

    <!-- Payment Responsibility Modal -->
    <PaymentResponsibilityModal :dialog="showPaymentResponsibilityModal" :item="selectedPaymentItem"
      @close="showPaymentResponsibilityModal = false" @respond="handlePaymentResponsibilityRespond" />

    <!-- Report Payment Modal -->
    <ReportPaymentModal :dialog="showReportPaymentModal" :item="selectedPaymentItem"
      :payment="selectedPaymentItem && selectedPaymentItem.payment"
      :bankDetails="ddsPaymentBankDetails" @close="showReportPaymentModal = false"
      @confirm="handleReportPaymentConfirm" @error="handleReportPaymentError" />

    <!-- Verify Payment Modal -->
    <VerifyPaymentModal :dialog="showVerifyPaymentModal" :item="selectedPaymentItem"
      :payment="selectedPaymentItem && selectedPaymentItem.payment"
      :payerLabel="demoVerifyPayerLabel"
      :payerInfo="selectedVerifyPayerInfo"
      :bankDetails="ddsPaymentBankDetails"
      @close="showVerifyPaymentModal = false"
      @confirm="handleVerifyPaymentConfirm" />

    <!-- View Invoice Modal (professional invoice for exporters) -->
    <ViewInvoiceModal :dialog="showViewInvoiceModal" :item="selectedInvoiceItem"
      :bankDetails="ddsPaymentBankDetails" :payerInfo="selectedInvoicePayerInfo"
      @close="showViewInvoiceModal = false" />

    <DDSDashboardGuide />
  </div>
</template>
  
  <script>
  import Breadcrumb from "@/components/core/Breadcrumb";
  // import VueApexCharts from "vue-apexcharts";
  import DeforestationService from "@/_services/DeforestationService";
  import ProfileService from "@/_services/ProfileService";
  import ActivityLogService from "@/_services/ActivityLogService";
  import loadingMixin from "@/mixins/LoadingMixin";
  import download from "@/mixins/DownloadMixin";
  import getPermittedActions from "@/mixins/GetPermittedActions";
  import DateMixin from "@/mixins/DateMixin";
  import { getCountries } from "country-state-picker";
  import html2pdf from "html2pdf.js";
  import printJS from "print-js";
  import { getRiskAssessmentStatus, getReportRiskStatusMeta } from '@/utils';
  import UnitService from "@/_services/UnitService";
  import { mapGetters } from "vuex";
  import moment from 'moment';
  import tableCustomizationMixin from '@/mixins/tableCustomizationMixin';
  import { currentRoles } from "@/utils";
  import RoleMixin from "@/mixins/RoleMixin";
  import { PTSI_WORKER_ROLES, PTSI_ADMIN_ROLES } from "@/constants/roles";
  import ConfirmBox from "@/components/ConfirmBox";
  import { isDdsExporter, isIndonesianClient, isKenyaClient, getEUDRDeforestationStatus, isPendingApprovalStatus, isDdsCompliantStatus, isDdsNonCompliantStatus, isWaitingForPaymentStatus, isPaymentPendingVerificationStatus, hasActivePaymentStatusLegend, normalizeDdsStatus, resolveDdsExporterPayerFields, canVerifyDdsPayment, isDdsExporterLockedOutByPayment } from "@/utils";
import DDSDashboardGuide from '../../components/DDSDashboardGuide.vue';
import ReportPaymentModal from '../approval-flow/components/ReportPaymentModal.vue';
import VerifyPaymentModal from '../approval-flow/components/VerifyPaymentModal.vue';
import PaymentResponsibilityModal from '../approval-flow/components/PaymentResponsibilityModal.vue';
import ViewInvoiceModal from '../approval-flow/components/ViewInvoiceModal.vue';
import PaymentUnavailableStatus from '../../components/PaymentUnavailableStatus.vue';
  export default {
    components: {
      breadcrumb: Breadcrumb,
      // apexchart: VueApexCharts,
      "confirm-box": ConfirmBox,
      DDSDashboardGuide,
      ReportPaymentModal,
      VerifyPaymentModal,
      ViewInvoiceModal,
      PaymentResponsibilityModal,
      PaymentUnavailableStatus,
    },
  
    computed: {
    ...mapGetters("eudrDDS", ["getDdsUserRole"]),
    isIndonesianClient() {
      return isIndonesianClient();
    },
    isKenyaClient() {
      return isKenyaClient();
    },
    isPtsiApprovalClient() {
      return isIndonesianClient() || isKenyaClient();
    },
    visibleReportHeaders() {
      const headers = this.isPtsiApprovalClient
        ? this.reportHeaders
        : this.reportHeaders.filter((header) => header.value !== 'riskStatus');

      return headers.map((header) => {
        if (header.value === 'EUDRReferenceNumber') {
          return {
            ...header,
            text: this.isKenyaClient
              ? this.$t('deforestation.internalRefNoKenya')
              : this.$t('deforestation.eudrAndInternalRefNo'),
          };
        }
        return header;
      });
    },
    isSupplierOwner() {
        return currentRoles()?.some(role => ['supplier_owner'].includes(role));
      },
      isOperatorOwner() {
        return currentRoles()?.some(role => ['operator_owner'].includes(role));
      },
      isOperator() {
        return ProfileService.checkRole("operator");
      },
      isSupplier() {
        return ProfileService.checkRole("supplier");
      },
      isPtsiPanelOnly() {
        return this.getCurrentRoles?.some(role => PTSI_ADMIN_ROLES.includes(role));
      },
      isWorkerOnly() {
        return this.getCurrentRoles?.some(role => PTSI_WORKER_ROLES.includes(role));
      },
      isPtsiReviewer() {
        return this.isPtsiPanelOnly || this.isWorkerOnly;
      },
      getOrganizationId() {
              return this.$store.getters.getUser?.user_organization?.id;
          },
      totalPages() {
        return parseInt(Math.ceil(this.totalProductionPlaces / 10));
      },
      currentUser() {
        return this.$store.getters.getUser;
      },
  
      reportTotalPages() {
        return parseInt(Math.ceil(this.totalDiligenceReports / 10))
      },
  
      getSupplierFullName() {
        return (item) => {
          const firstName = item.supplier?.firstName ?? '';
          const lastName = item.supplier?.lastName ?? '';
          return `${firstName} ${lastName}`.trim();
        };
      },
  
      getFarmSupplierFullName() {
        return (item) => {
          const firstName = item.diligenceReport?.supplier?.firstName ?? '';
          const lastName = item.diligenceReport?.supplier?.lastName ?? '';
          return `${firstName} ${lastName}`.trim();
        };
      }
    },
    async mounted() {
      if (this.isOperator) {
        return;
      }
      await Promise.allSettled([
        this.getEudrSettings(),
      ])
      this.fetchAllProducers(); // Fetch all producers once
      if(this.isOperatorOwner)this.getSupplierList();
      
      const data = JSON.parse(localStorage.getItem("downloadPdfAlert"));

      if (data) {
        const { estimatedTime, downloadId } = data;
        
        this.alertData = {
          show: true,
          downloadId: downloadId,
          estimatedTime: estimatedTime,
        };

        // remove alert after 10sec;
        setTimeout(() => {
          localStorage.removeItem("downloadPdfAlert");
          this.alertData.show = false;
        }, 10000);
      }
    },
  
    async created() {
      const prefs = this.getTablePrefs('DueDiligenceReportTable');
      if (prefs) {
        this.selectedHeaders = prefs.selectedHeaders;
        this.itemsPerPageSlider = this.itemsPerPageOptions.indexOf(prefs.itemsPerPage);
      } else {
        this.selectedHeaders = this.reportHeaders.map(h => h.text);
        this.itemsPerPageSlider = 1;
      }

      this.reportOptions.itemsPerPage = this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.tableHeaders = this.visibleReportHeaders.filter(header =>
        this.selectedHeaders.includes(header.text) || header.value === 'actions'
      );
      if (this.isOperator) {
        return;
      }
      this.orgId = this.currentUser.user_organization.id;
      await this.getCountry();
      await this.getDeforestationEUDR();
      await this.getUsageLimit(this.orgId).then(async () => {
        await this.processUsageLimits();
        await this.getProductionPlaces();
        setTimeout(() => {
          this.createDeligenceChart();
          this.createDeforestationChart()
          this.createRiskAssessmentChart()
        }, 100)
      });
    },
    watch: {
    // Watchers on filter fields to trigger getProductionPlaces() whenever any filter changes
    placeCountry() {
      this.fromProducer = 1;
      this.toProducer = 10;
      this.options.page = 1;
      this.getProductionPlaces();
    },
    producerModel() {
      this.fromProducer = 0;
      this.toProducer = 10;
      this.options.page = 1;
      this.getProductionPlaces();
    },
    placeStatus() {
      this.fromProducer = 0;
      this.toProducer = 10;
      this.options.page = 1;
      this.getProductionPlaces();
    },
  },
    data() {
      return {
        isDdsExporter: isDdsExporter(),
        alertData: {
          show: false,
          downloadId: '',
          estimatedTime: '',
        },
        orgId: undefined,
        document: '',
        loading: true,
        listOfFarmloading: true,
        countries: [{ text: this.$t("deforestation.allCountries"), val: "" }],
        allProducers: [{ text: this.$t("deforestation.allProducer"), val: "" }],
        options: {
          page: 1,
          limit: 10,
        },
        usageLimits: [],
        series: [80],
        responseData: null,
        dueDeligence: null,
        dueDeligenceSeries: [],
        eudrDeforestationAssessment: null,
        eudrDeforestationSeries: [],
        riskAssessment: null,
        riskAssessmentSeries: [],
        dueDiligenceChartOptions: undefined,
        deforestationChartOptions: undefined,
        riskAssessmentChartOptions: undefined,
        breadcrumbs: [
          {
            text: this.$t("dueDiligence.dueDiligenceNew"),
            disabled: true,
            to: "/",
          },
          {
            text: this.$t("dueDiligence.createNewReport"),
            disabled: true,
            to: "/",
          },
        ],
        selected: [],
        placesHeaders: [
          {
            text: this.$t("dueDiligence.productionPlaceAndFarmID"),
            align: "start",
            sortable: true,
            value: "farm.farmName",
            class: "black--text",
            width: "150px",
          },
          {
            text: this.$t("deforestation.producer"),
            align: "start",
            sortable: true,
            value: "farm.userDdsAssoc.fullName",
            class: "black--text",
            width: "150px",
          },
          {
            text: this.$t("deforestation.supplier"),
            align: "start",
            value: "supplier",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.addressOfProduction"),
            align: "start",
            sortable: true,
            value: "farm.address",
            class: "black--text",
            width: "150px",
          },
          {
            text: `${this.$t("deforestation.EUDRDeforestationStatus")}`,
            value: "eudr_deforestation_status",
            sortable: true,
            class: "black--text",
            width: "95px",
          },
          {
            text: `${this.$t("deforestation.riskAssessment")}`,
            value: "risk_assessment",
            sortable: false,
            class: "black--text",
            width: "95px",
          },
          {
            text: this.$t('dueDiligence.actions'),
            align: "center",
            value: "actions",
            class: "black--text",
            sortable: false,
          },
        ],
        productionPlaces: [],
        totalProductionPlaces: 0,
        fromProducer: 0,
        toProducer: 0,
        farmStatus: "success",
        farmStatusList: [],
        placeSearch: "",
        placeCountry: "All Countries",
        placeStatus: "",
        producerModel: "",
  
        //due deligence
        reportCountry: "",
        reportStatus: "",
        reportSearch: "",
        //regionModel: '',
  
        allStatus: [
          { text: this.$t("deforestation.allStatus"), val: "" },
          {
            text: this.$t("deforestation.uploadedToEU"),
            val: "Uploaded to EU Portal",
          },
          { text: this.$t("deforestation.pending"), val: "Pending" },
          { text: this.$t("deforestation.underReview"), val: "Under Review" },
          { text: this.$t("deforestation.nonCompliant"), val: "Non-Compliant" },
          { text: this.$t("deforestation.compliant"), val: "Compliant" },
          { text: this.$t("deforestation.analyzeDeforestation"), val: "Analyzing Deforestation" },
          { text: this.$t("deforestation.readyToProceed"), val: "Ready To Proceed" },
        ],
        allRegions: [{ text: this.$t("deforestation.allRegions"), val: "" }],
  
        diligenceReports: [],
        //copyReport: [],
        totalDiligenceReports: 0,
        totalDiligenceReportsPages: 0,
        selectedItem: false,
        reportOptions: {
          itemsPerPage: 10,
          page: 1,
        },
  
        toDiligenceReports: 0,
        fromDiligenceReports: 0,
        reportHeaders: [
          {
            text: this.$t("deforestation.eudrAndInternalRefNo"),
            align: "start",
            value: "EUDRReferenceNumber",
            class: "black--text",
            sortable: true,
            width: "150px",
          },
          {
            text: this.$t("deforestation.supplier"),
            align: "start",
            value: "supplier",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.product"),
            align: "start",
            value: "product",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.farmsAndQuantity"),
            align: "start",
            value: "productNetMass",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.country"),
            align: "start",
            value: "countryOfEntry",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.submissionDate"),
            align: "start",
            value: "createdAt",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.riskStatus"),
            align: "center",
            value: "riskStatus",
            class: "black--text",
            sortable: true,
          },
          {
            text: this.$t("deforestation.dueDeligenceStatus"),
            align: "start",
            value: "dueDeligenceStatus",
            class: "black--text",
            sortable: true,
          },
          {
            text: '',
            align: "center",
            value: "actions",
            class: "black--text",
            sortable: false,
            width: "56px",
          },
        ],
        menu: false,
        itemsPerPageOptions: [5, 10, 25, 50],
        itemsPerPageSlider: 1,
        selectedHeaders: [],
        tableHeaders: [],
        eudrSettings: {},
        confirmDeleteDialog : false,
        confirmDelete: {
          title: this.$t("confirmDialog.dueDiligenceReport.delete.title"),
          message: this.$t("confirmDialog.dueDiligenceReport.delete.message"),
          confirmBtnText: this.$t("confirmDialog.dueDiligenceReport.delete.confirmBtn"),
          cancelBtnText: this.$t("cancel"),
          confirmData: {},
        },
        farmConfirmDeleteDialog : false,
        farmConfirmDelete: {
          title: this.$t("confirmDialog.farm.delete.title"),
          message: this.$t("confirmDialog.farm.delete.message"),
          confirmBtnText: this.$t("confirmDialog.farm.delete.confirmBtn"),
          cancelBtnText: this.$t("cancel"),
          confirmData: {},
        },
        deforestationStatus:[
          { text: this.$t("deforestation.allStatus"), val: "" },
          { text: this.$t("deforestation.veryHighDeforestationProbability"), val: "Very High Deforestation Probability" },
          { text: this.$t("deforestation.highDeforestationProbability"), val: "High Deforestation Probability" },
          { text: this.$t("deforestation.mediumDeforestationProbability"), val: "Medium Deforestation Probability" },
          { text: this.$t("deforestation.lowDeforestationProbability"), val: "Low Deforestation Probability" },
          { text: this.$t("deforestation.veryLowDeforestationProbability"), val: "Very Low Deforestation Probability" },
          { text: this.$t("deforestation.zeroNegligibleDeforestationProbability"), val: "Zero/Negligible Deforestation Probability" },
          { text: this.$t("deforestation.zeroOrNegligibleRisk"), val: "Zero/Negligible Risk" },
          { text: this.$t("deforestation.riskDetected"), val: "Risk Detected" },
          { text: this.$t("deforestation.manuallyMitigated"), val: "Manually Mitigated" },
        ],
        showFilters: false,
        supplierList: [],
        supplierModel: null,
        showPaymentResponsibilityModal: false,
        releasePaymentConfirmDialog: false,
        releasePaymentConfirmLoading: false,
        releasePaymentConfirm: {
          title: this.$t('confirmation'),
          message: this.$t('dueDiligence.releasePaymentResponsibilityConfirm'),
          confirmBtnText: this.$t('dueDiligence.releasePaymentResponsibility'),
          cancelBtnText: this.$t('cancel'),
          confirmData: {},
        },
        showReportPaymentModal: false,
        showVerifyPaymentModal: false,
        selectedVerifyPayerInfo: { name: '-', companyId: '-', contact: '-' },
        showViewInvoiceModal: false,
        selectedPaymentItem: null,
        selectedInvoiceItem: null,
        selectedInvoicePayerInfo: { name: '-', companyId: '-', contact: '-' },
        demoVerifyPayment: null,
        demoVerifyPayerLabel: '-',
        ddsPaymentBankDetails: {
          bankName: 'Bank Mandiri',
          accountName: 'PT Surveyor Indonesia',
          accountNumber: '123-456-7890',
        },
      };
    },
    methods: {
      isPendingApprovalStatus,
      isDdsCompliantStatus,
      isDdsNonCompliantStatus,
      isWaitingForPaymentStatus,
      isPaymentPendingVerificationStatus,
      hasActivePaymentStatusLegend,
      getRiskStatusMeta(item) {
        return getReportRiskStatusMeta(item?.riskStatus, this.$t.bind(this));
      },
      isCurrentUserDdsPayer(item) {
        // this.$store user.id is the platform-wide (cf) user id, so it must be compared
        // against payer_cf_id, not the DDS-service-internal payer_user_id.
        const currentUser = this.$store.getters.getUser;
        if (!currentUser || !item?.payment?.payer_cf_id) return false;
        return Number(item.payment.payer_cf_id) === Number(currentUser.id);
      },
      canReportPayment(item) {
        if (!isWaitingForPaymentStatus(item) || !item.payment) return false;
        if (this.needsPaymentResponse(item)) return false;
        // invoice_generated/rejected = normal path; pending = accepted but invoice not
        // promoted yet (legacy rows before auto-invoice-on-accept).
        if (!['invoice_generated', 'rejected', 'pending'].includes(normalizeDdsStatus(item.payment.status))) {
          return false;
        }
        const myEntry = this.myExporterEntry(item);
        // Payment workflow is only for the exporter who accepted responsibility.
        if (myEntry) {
          return normalizeDdsStatus(myEntry.payment_response_status) === 'accepted';
        }
        // Non-exporter path (e.g. cooperative payer on reports not shared to exporters).
        return this.isCurrentUserDdsPayer(item);
      },
      canReleasePaymentResponsibility(item) {
        if (!item?.payment) return false;
        // Only before a receipt is submitted — once reported/verified, responsibility is locked.
        if (!['pending', 'invoice_generated', 'rejected'].includes(normalizeDdsStatus(item.payment.status))) {
          return false;
        }
        const myEntry = this.myExporterEntry(item);
        return !!(myEntry && normalizeDdsStatus(myEntry.payment_response_status) === 'accepted');
      },
      confirmReleasePaymentResponsibility(item) {
        this.releasePaymentConfirm.confirmData = { item };
        this.releasePaymentConfirmLoading = false;
        this.releasePaymentConfirmDialog = true;
      },
      closeReleasePaymentConfirm() {
        if (this.releasePaymentConfirmLoading) return;
        this.releasePaymentConfirmDialog = false;
        this.releasePaymentConfirm.confirmData = {};
      },
      async handleReleasePaymentResponsibility(_action, confirmData) {
        const item = confirmData?.item || this.releasePaymentConfirm.confirmData?.item;
        if (!item) {
          this.closeReleasePaymentConfirm();
          return;
        }
        this.releasePaymentConfirmLoading = true;
        try {
          await DeforestationService.releaseDdsPaymentResponsibility({
            diligenceReportId: Number(item.id),
          });
          this.$toast?.success?.(this.$t('dueDiligence.paymentResponsibilityReleased'));
          this.getDeforestationEUDR();
        } catch (error) {
          console.error('Error releasing DDS payment responsibility:', error);
          this.$toast?.error?.(error?.message || this.$t('somethingWentWrong'));
        } finally {
          this.releasePaymentConfirmLoading = false;
          this.releasePaymentConfirmDialog = false;
          this.releasePaymentConfirm.confirmData = {};
        }
      },
      canVerifyPayment(item) {
        return canVerifyDdsPayment(item);
      },
      payerLabelForItem(item) {
        if (!item?.payment) return '-';
        if (normalizeDdsStatus(item.payment.payer_type) === 'exporter') {
          return this.$t('deforestation.exporter');
        }
        return this.isIndonesianClient
          ? this.$t('deforestation.cooperative')
          : this.$t('deforestation.supplier');
      },
      canViewInvoice(item) {
        if (!item?.payment) return false;
        const status = normalizeDdsStatus(item.payment.status);
        if (['invoice_generated', 'reported', 'verified', 'rejected'].includes(status)) return true;
        // After accept, invoice is prepared even if status is still pending on legacy rows.
        if (status === 'pending') {
          const myEntry = this.myExporterEntry(item);
          return myEntry && normalizeDdsStatus(myEntry.payment_response_status) === 'accepted';
        }
        return false;
      },
      invoiceMenuLabel(item) {
        return item?.payment?.receipt_s3_key
          ? this.$t('dueDiligence.viewInvoiceAndReceipt')
          : this.$t('dueDiligence.viewInvoice');
      },
      buildInvoicePayerInfo(item) {
        const user = this.$store.getters.getUser || {};
        const org = user.user_organization || user.organization || {};
        const payerCfId = item?.payment?.payer_cf_id;
        const payerExporter = (item?.ddsReportExporters || []).find(
          (exporter) => payerCfId && Number(exporter.exporter_cf_id) === Number(payerCfId)
        );
        const acceptedExporter = (item?.ddsReportExporters || []).find(
          (exporter) => normalizeDdsStatus(exporter.payment_response_status) === 'accepted'
        );
        const responsibleExporter = payerExporter || acceptedExporter;
        const isCurrentUserPayer = payerCfId && Number(payerCfId) === Number(user.id);

        if (responsibleExporter) {
          const resolved = resolveDdsExporterPayerFields(responsibleExporter, item?.companyID);
          if (!isCurrentUserPayer) {
            return {
              name: resolved.name !== '-' ? resolved.name : this.$t('dueDiligence.receiptSubmittedByAnotherExporter'),
              companyId: resolved.companyId,
              contact: resolved.contact,
            };
          }
          return resolved;
        }

        const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim()
          || org.name
          || '-';
        return {
          name,
          companyId: item?.companyID || org.id || user.id || '-',
          contact: user.email || user.mobile || '-',
        };
      },
      async openViewInvoiceModal(item) {
        this.selectedInvoiceItem = item;
        this.selectedInvoicePayerInfo = this.buildInvoicePayerInfo(item);
        this.showViewInvoiceModal = true;

        // Legacy accepted payments may still be PENDING without invoice_number/date.
        // Ensure those fields exist before the modal is useful.
        if (!item?.payment || (item.payment.invoice_number && item.payment.invoice_generated_at)) {
          return;
        }
        try {
          let payment = null;
          const status = normalizeDdsStatus(item.payment.status);
          if (status === 'pending' || (status === 'invoice_generated' && !item.payment.invoice_number)) {
            try {
              const res = await DeforestationService.generateDdsInvoice({
                diligenceReportId: Number(item.id),
                amount: item.payment.amount != null ? Number(item.payment.amount) : undefined,
              });
              payment = res?.data?.generateDdsInvoice || null;
            } catch (e) {
              const res = await DeforestationService.getDdsPaymentByReportId(Number(item.id));
              payment = res?.data?.ddsPaymentByReportId || null;
            }
          } else {
            const res = await DeforestationService.getDdsPaymentByReportId(Number(item.id));
            payment = res?.data?.ddsPaymentByReportId || null;
          }
          if (payment) {
            this.selectedInvoiceItem = {
              ...item,
              payment: { ...item.payment, ...payment },
            };
            this.getDeforestationEUDR();
          }
        } catch (error) {
          console.error('Error ensuring DDS invoice fields:', error);
        }
      },
      myExporterEntry(item) {
        const currentUser = this.$store.getters.getUser;
        if (!currentUser || !item?.ddsReportExporters?.length) return null;
        return item.ddsReportExporters.find(
          (exporter) => Number(exporter.exporter_cf_id) === Number(currentUser.id)
        ) || null;
      },
      needsPaymentResponse(item) {
        if (!isWaitingForPaymentStatus(item) || !item?.payment) return false;
        const myEntry = this.myExporterEntry(item);
        if (!myEntry || normalizeDdsStatus(myEntry.payment_response_status) !== 'pending') return false;
        // payment.payer_cf_id can be stale (auto-assigned before anyone explicitly
        // responded), so the source of truth for "already resolved" is whether some
        // other exporter's own row has been explicitly accepted. Status strings from
        // this backend have inconsistent casing, so compare normalized.
        const someoneElseAccepted = (item.ddsReportExporters || []).some(
          (exporter) => normalizeDdsStatus(exporter.payment_response_status) === 'accepted'
            && Number(exporter.exporter_cf_id) !== Number(myEntry.exporter_cf_id)
        );
        return !someoneElseAccepted;
      },
      openPaymentResponsibilityModal(item) {
        this.selectedPaymentItem = item;
        this.showPaymentResponsibilityModal = true;
      },
      async handlePaymentResponsibilityRespond(payload) {
        const accept = typeof payload === 'boolean' ? payload : payload?.accept;
        const done = typeof payload === 'object' ? payload?.done : null;
        if (!this.selectedPaymentItem) {
          done?.(new Error('No payment item selected'));
          return;
        }
        try {
          await DeforestationService.respondToDdsPaymentResponsibility({
            diligenceReportId: Number(this.selectedPaymentItem.id),
            accept,
          });
          this.$toast?.success?.(
            accept
              ? this.$t('dueDiligence.paymentResponsibilityAccepted')
              : this.$t('dueDiligence.paymentResponsibilityDeclined')
          );
          this.getDeforestationEUDR();
          this.selectedPaymentItem = null;
          done?.();
        } catch (error) {
          console.error('Error responding to DDS payment responsibility:', error);
          this.$toast?.error?.(error?.message || this.$t('somethingWentWrong'));
          done?.(error);
        }
      },
      openReportPaymentModal(item) {
        this.selectedPaymentItem = {
          ...item,
          payment: item.payment || {
            amount: 1500000,
            currency: 'IDR',
            status: 'pending',
          },
        };
        this.showReportPaymentModal = true;
      },
      openVerifyPaymentModal(item) {
        this.selectedPaymentItem = item;
        this.demoVerifyPayerLabel = this.payerLabelForItem(item);
        this.selectedVerifyPayerInfo = this.buildInvoicePayerInfo(item);
        this.showVerifyPaymentModal = true;
      },
      async handleVerifyPaymentConfirm(payload) {
        if (!this.selectedPaymentItem) {
          payload?.done?.(new Error('No payment item selected'));
          return;
        }
        const { done, ...verifyPayload } = payload || {};
        try {
          await DeforestationService.verifyDdsPayment({
            diligenceReportId: Number(this.selectedPaymentItem.id),
            ...verifyPayload,
          });
          this.$toast?.success?.(
            verifyPayload?.approved
              ? this.$t('dueDiligence.paymentVerified')
              : this.$t('dueDiligence.paymentRejected')
          );
          this.getDeforestationEUDR();
          done?.();
        } catch (error) {
          console.error('Error verifying DDS payment:', error);
          this.$toast?.error?.(error?.message || this.$t('somethingWentWrong'));
          done?.(error);
        } finally {
          this.selectedPaymentItem = null;
        }
      },
      async handleReportPaymentConfirm(payload) {
        if (!this.selectedPaymentItem) {
          payload?.done?.(new Error('No payment item selected'));
          return;
        }
        const { done, ...reportPayload } = payload || {};
        try {
          await DeforestationService.reportDdsPayment({
            diligenceReportId: Number(this.selectedPaymentItem.id),
            ...reportPayload,
          });
          this.$toast?.success?.(this.$t('dueDiligence.paymentReportedSuccessfully'));
          this.showReportPaymentModal = false;
          this.getDeforestationEUDR();
          done?.();
        } catch (error) {
          this.handleReportPaymentError(error);
          done?.(error);
        } finally {
          this.selectedPaymentItem = null;
        }
      },
      handleReportPaymentError(error) {
        console.error('Error reporting DDS payment:', error);
        this.$toast?.error?.(error?.message || this.$t('somethingWentWrong'));
      },
      getEUDRDeforestationStatus(status) {
        return getEUDRDeforestationStatus(status, this.$t.bind(this));
      },
      closeAlert() {
        this.alertData.show = false;
        localStorage.removeItem("downloadPdfAlert");
      },

      showAllDownloads() {
        this.$router.push({ name: "DownloadHistory" });
      },
      
      getDateFormat(date) {
        if(!date) return ''
        return moment(date).format("DD/MM/YYYY");
      },
      getRiskAssessmentStatus,
      async exportToPDF() {
        const requestParams = {
          page: this.reportOptions.page,
          limit: this.reportOptions.itemsPerPage,
          searchPhrase: this.reportSearch,
          country: this.reportCountry,
          status: this.reportStatus,
        };
        const querys = new URLSearchParams(requestParams).toString();
        const token = this.$store.state.auth.token
        this.startLoading()
        const url = localStorage.getItem('CF_DEFORESTATION_API_BASE_URL') || process.env.VUE_APP_DEFORESTRATION_API_BASE_URL  || "https://cf-deforestation.dimitra.dev/graphql"
        this.downloadSourceFileWithToken(`${url}/diligence-report/diligence-report-csv?${querys}`, "application/vnd.ms-excel", token,"diligence-reports.xls")
          .then(() => {
            this.stopLoading()
          }).catch(() => {
            this.stopLoading()
        })
      },
      async printPDF() {
        const element = document.querySelector(".v-data-table__wrapper");
        let opt = {
          margin: 1,
          filename: "Suppliers.pdf",
          image: { type: "jpeg", quality: 0.95 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
        };
  
        let worker = await html2pdf()
          .set(opt)
          .from(element)
          .toCanvas()
          .outputPdf("blob", "Suppliers.pdf");
        let file = new File([worker], "Suppliers.pdf", {
          type: "application/pdf",
        });
        var pdfUrl = await URL.createObjectURL(file);
        await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
      },
      async resetDefaut() {
        this.selectedHeaders = this.visibleReportHeaders.map(h => h.text);
        this.tableHeaders = this.visibleReportHeaders;
        this.reportOptions.itemsPerPage = 10;
        this.itemsPerPageSlider = 1;

        this.clearTablePrefs('DueDiligenceReportTable');
        await this.getDeforestationEUDR();
        this.menu = false;
      },
      async resetTableStructure() {
        this.menu = false;
        this.document = false; 

        if (!this.selectedHeaders.length) {
          this.selectedHeaders = this.visibleReportHeaders.map(h => h.text);
        }

        this.tableHeaders = this.visibleReportHeaders.filter(header =>
          this.selectedHeaders.includes(header.text) || header.value === 'actions'
        );

        const selectedPerPage = this.itemsPerPageOptions[this.itemsPerPageSlider];
        this.reportOptions.itemsPerPage = selectedPerPage;

        this.setTablePrefs('DueDiligenceReportTable', {
          selectedHeaders: this.selectedHeaders,
          itemsPerPage: selectedPerPage
        });

        await this.getDeforestationEUDR();
      },
      async processUsageLimits() {
        this.usageLimits?.forEach((item) => {
          let percentage;
          switch (item.report_type.name) {
            case "Due Diligence Reports":
              this.dueDeligence = item;
              percentage = (this.dueDeligence.used / this.dueDeligence.limit) * 100;
              this.dueDeligenceSeries.push(percentage.toFixed(1));
              break;
            case "EUDR Deforestation Assessments":
              this.eudrDeforestationAssessment = item;
              percentage =
                (this.eudrDeforestationAssessment.used /
                  this.eudrDeforestationAssessment.limit) * 100;
              this.eudrDeforestationSeries.push(percentage.toFixed(1));
              break;
            case "Risk Assessments":
              this.riskAssessment = item;
              percentage = (this.riskAssessment.used / this.riskAssessment.limit) * 100;
              this.riskAssessmentSeries.push(percentage.toFixed(1));
              break;
            default:
              break;
          }
        });
      },
      redirectToProducer(){
        this.$router.push({
          name:'Producers'
        })
      },
      redirectToCreateDueDiligence() {
        this.$store.dispatch('SET_DDS_TAB', {
          activeTab: 1
        }).then(() => {
          this.$router.push({
            name: "createDueDiligenceReports"
          })
        })
      },
      redirectTodueDiligenceReports() {
        this.$router.push({
          name: "dueDiligenceReports"
        })
      },
      redirectToSettings() {
        this.$router.push({
          name: "EUDRSettings"
        })
      },
      redirectToMyFarms() {
        this.$router.push({
          name: "supplierFarms"
        })
      },
      async getUsageLimit(orgId) {
        this.startLoading();
        return new Promise((resolve, reject) => {
          const params = {
            organizationId: orgId,
          };
          DeforestationService.getUsesLimit(params).then(res => {
            this.usageLimits = res?.data?.usageLimits || [];
            this.stopLoading()
            resolve()
          }).catch(err => {
            reject(err)
          });
  
        })
      },
  
      createDeligenceChart() {
        let used = this.dueDeligence?.used
        this.dueDiligenceChartOptions = {
          chart: {
            height: 350,
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "70%",
              },
              dataLabels: {
                name: {
                  offsetY: 20,
                  fontSize: "14px",
                  color: "#1E1E1E", // Green color for the label text
                  show: true,
                },
                value: {
                  fontSize: "36px",
                  show: true,
                  color: "#1E1E1E", // Green color for the value text
                  offsetY: -10,
                  formatter: function () {
                    return used
                  }
                },
              },
              track: {
                background: "#e0e0e0",
              },
            },
          },
          fill: {
            colors: ["#0EBF67"], // Green color for the chart
          },
  
          labels: [this.$t('used')],
  
        }
      },
  
      createDeforestationChart() {
        let used = this.eudrDeforestationAssessment?.used
        this.deforestationChartOptions = {
          chart: {
            height: 350,
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "70%",
              },
              dataLabels: {
                name: {
                  offsetY: 20,
                  fontSize: "14px",
                  color: "#1E1E1E", // Green color for the label text
                  show: true,
                },
                value: {
                  fontSize: "36px",
                  show: true,
                  color: "#1E1E1E", // Green color for the value text
                  offsetY: -10,
                  formatter: function () {
                    return used
                  }
                },
              },
              track: {
                background: "#e0e0e0",
              },
            },
          },
          fill: {
            colors: ["#0EBF67"], // Green color for the chart
          },
  
          labels: [this.$t('used')],
  
        }
      },
  
      createRiskAssessmentChart() {
        let used = this.riskAssessment?.used
        this.riskAssessmentChartOptions = {
          chart: {
            height: 350,
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "70%",
              },
              dataLabels: {
                name: {
                  offsetY: 20,
                  fontSize: "14px",
                  color: "#1E1E1E", // Green color for the label text
                  show: true,
                },
                value: {
                  fontSize: "36px",
                  show: true,
                  color: "#1E1E1E", // Green color for the value text
                  offsetY: -10,
                  formatter: function () {
                    return used
                  }
                },
              },
              track: {
                background: "#e0e0e0",
              },
            },
          },
          fill: {
            colors: ["#0EBF67"], // Green color for the chart
          },
  
          labels: [this.$t('used')],
  
        }
      },
      async fetchAllProducers() {
      try {
        const res = await DeforestationService.getProductionPlaces({
          page: 1,
          limit: 500, // Adjust limit as needed
          orgId: this.orgId,
          removed: false,
        });
        const producers = res.data?.productionPlaces?.rows
          .filter(item => item.farm?.userDdsAssoc?.firstName)
          .map(item => ({
            text: `${item.farm?.userDdsAssoc?.firstName || ''} ${item.farm?.userDdsAssoc?.lastName || ''}`.trim(),
            val: item.farm?.userDdsAssoc?.firstName
          }));
        this.allProducers = [...this.allProducers, ...producers];
      } catch (error) {
        console.error("Error fetching all producers:", error);
      }
    },
    async getSupplierList() {
        return DeforestationService.getSupplierList().then(res => {
            this.supplierList = res.data.findAllSuppliersOrOperators?.map((item)=>{
              return {
                label:item.firstName + ' ' + item.lastName,
                val:parseInt(item.id)
              }
            }) || [];
          if (this.isSupplierOwner) {
            const label = `${this.currentUser.firstName} ${this.currentUser.lastName}`;
            this.supplierList.unshift({
              label: label,
              val: null
            });
          }
        }).catch(err => {
            console.log('Error', err)
        })
    },
      async getProductionPlaces(opt = null) {
        this.listOfFarmloading = true;
        
        
        const requestParams = {
          page: this.options.page,
          limit: this.options.limit,
          orgId: this.orgId,
          removed: false,
          searchPhrase: this.placeSearch,
          farmCountry: this.placeCountry,
          farmOwner: this.producerModel,
          eudrDeforestationStatus: this.placeStatus,
          supplierId: parseInt(this.supplierModel),
        };
        if (opt?.sortBy?.length) {
          requestParams.orderField = opt.sortBy[0];
          requestParams.order = opt.sortDesc[0] ? "DESC" : "ASC";
        }
        await DeforestationService.getProductionPlaces(requestParams)
          .then((res) => {
            this.productionPlaces = res.data.productionPlaces.rows;
            
            this.totalProductionPlaces = res.data.productionPlaces.totalCount;
            this.fromProducer = (this.options.page - 1) * this.options.limit + 1;
            this.toProducer = this.options.page * this.options.limit;
            if (this.productionPlaces.length > 0) {
              this.toProducer -= this.options.limit - this.productionPlaces.length;
            } else {
              this.toProducer -= this.options.limit;
            }
            if (this.totalProductionPlaces < 1) {
              this.toProducer = 0;
              this.fromProducer = 0;
              this.options.page = 1;
            }
            const countryLists = this.productionPlaces
              .filter((item) => item.farm.userDdsAssoc.countryId)
              .map((item) => {
                return {
                  text: item.farm.userDdsAssoc.countryId,
                  val: item.farm.userDdsAssoc.countryId,
                };
              });
            const producerList = this.productionPlaces
              .filter((item) => {
                return item.farm.userDdsAssoc.firstName;
              })
              .map((item) => {
                const fullName = `${item.farm.userDdsAssoc.firstName
                  ? item.farm.userDdsAssoc.firstName
                  : ""
                  } ${item.farm.userDdsAssoc.lastName ? item.farm.userDdsAssoc.lastName : ""
                  }`;
                return {
                  text: `${fullName}`,
                  val: `${item.farm.userDdsAssoc.firstName}`,
                };
              });
            this.countries = [...this.countries, ...countryLists];
            this.allProducers = [...this.allProducers, ...producerList];
          })
          .catch((err) => {
            this.listOfFarmloading = false;
            console.log("Error", err);
          })
          .finally(() => {
            this.listOfFarmloading = false;
          });
      },
   async removeFarm(id){
    this.farmConfirmDelete.confirmData = { id };
    this.farmConfirmDeleteDialog = true;
   },
      async confirmRemoveFarm(action, confirmData) {
        this.startLoading();
        const params = {
          farmId: parseInt(confirmData.id),
        };
        const res = await DeforestationService.removeProductionPlaceByFarmId(
          params
        );
  
        const { success, message } = res.data.removeFarmFromProductionPlaceList;
        this.stopLoading();
        if (success) {
          // Log the production place deletion
          try {
            const userId = this.$store.getters.getUser?.id;
            if (userId) {
              await ActivityLogService.logDDSProductionPlaceDeleted(
                null, // diligenceId not available in this context
                userId,
                confirmData.id,
                '',
                'Dashboard deletion'
              );
            }
          } catch (logError) {
            console.error('Error logging production place deletion:', logError);
          }
          
          await this.getProductionPlaces();
          this.farmConfirmDeleteDialog = false;
          this.$notify({
            title: message || this.$t("deforestation.itemDeletedSuccessfully"),
            type: "success",
          });
        }
      },
  
      handleSearchByPharse() {
      return this.getProductionPlaces()||"";
       },
      handleSearchByStatus() { },
  
      handleSearchOnEmpty() {
        this.placeCountry = "";
        this.options = {
          page: 1,
          limit: 10,
        };
        this.getProductionPlaces();
      },
      pageChange(t) {
        if (t) this.options.page = this.options.page + 1;
        else this.options.page = this.options.page - 1;
        this.getProductionPlaces();
      },
      getCountry() {
        this.countries = [{ name: this.$t("deforestation.allCountries") }, ...getCountries()];
      },
  
      async deleteDiligenceReports(id) {
       
        this.confirmDelete.confirmData = { id };
        this.confirmDeleteDialog = true;
      },
  
      async confirmDeleteDiligenceReport(action, confirmData){
        this.loading = true;
  
        DeforestationService.deleteDiligenceReport(parseInt(confirmData.id))
          .then(() => {
            this.getDeforestationEUDR();
            this.$notify({
              text: this.$t("deforestation.reportDeletedSuccessfully"),
              type: "success",
            });
            this.loading = false;
            this.confirmDeleteDialog = false;
  
          })
          .catch((err) => {
            this.loading = false;
            this.confirmDeleteDialog = false;
            this.$notify({
              text: err,
              type: "error",
            });
            console.log("Error", err);
          });
        },
      async duplicateDiligenceReports(id) {
        this.loading = true;
  
        DeforestationService.duplicateDiligenceReport(parseInt(id))
          .then(() => {
            this.getDeforestationEUDR();
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.$notify({
              text: err,
              type: "error",
            });
            console.log("Error", err);
          });
      },
  
      onReportOptionsUpdate(newOptions) {
        const sortChanged = JSON.stringify(newOptions.sortBy) !== JSON.stringify(this.reportOptions.sortBy)
          || JSON.stringify(newOptions.sortDesc) !== JSON.stringify(this.reportOptions.sortDesc);

        this.reportOptions = newOptions;

        if (sortChanged) {
          this.reportOptions.page = 1;
        }
        this.getDeforestationEUDR(this.reportOptions);
      },
      async getDeforestationEUDR(opt = null) {
        this.loading = true;
        const requestParams = {
          page: this.reportOptions.page,
          limit: this.reportOptions.itemsPerPage,
          searchPhrase: this.reportSearch,
          country: this.reportCountry,
          status: this.reportStatus,
          cfroles:currentRoles()
        };

        if (opt?.sortBy?.length) {
          const SORT_FIELD_MAP = { supplier: 'supplier.firstName', dueDeligenceStatus: 'status' };
          requestParams.orderField = SORT_FIELD_MAP[opt.sortBy[0]] || opt.sortBy[0];
          requestParams.order = opt.sortDesc[0] ? "DESC" : "ASC";
        }
        DeforestationService.getDiligenceReports(requestParams)
          .then((res) => {
            this.diligenceReports = res.data.diligenceReports.rows;
            
            //this.copyReport = JSON.parse(JSON.stringify(res.data.deforestationAdmin.rows))
            this.totalDiligenceReports = res.data.diligenceReports.totalCount;
  
            this.totalDiligenceReportsPages = Math.ceil(
              this.totalDiligenceReports / this.reportOptions.itemsPerPage
            );
            this.fromDiligenceReports = this.totalDiligenceReports > 0
              ? (this.reportOptions.page - 1) * this.reportOptions.itemsPerPage + 1
              : 0;
            this.toDiligenceReports = this.reportOptions.page * this.reportOptions.itemsPerPage > this.totalDiligenceReports
              ? this.totalDiligenceReports
              : this.reportOptions.page * this.reportOptions.itemsPerPage;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            console.log("Error", err);
          });
      },
      selectItem(item) {
        this.selectedItem = item;
      },
      searchQuery() {
        this.getDeforestationEUDR();
      },
      resetSearchOnEmpty() {
        this.reportSearch = "";
        this.reportCountry = "";
        this.reportStatus = "";      
        //this.regionModelregionModel = ''
        this.reportOptions = {
          page: 1,
          limit: 10,
        };
  
        this.getDeforestationEUDR();
      },
      reportPageChange(t) {
        if (t) this.reportOptions.page = this.reportOptions.page + 1;
        else this.reportOptions.page = this.reportOptions.page - 1;
        this.getDeforestationEUDR();
      },
      redirectToExporterSummary(reportId) {
        this.$router.push({
          name: 'ExporterSummaryReport',
          params: { id: reportId }
        })
      },
      redirectToDDSSUmmary(reportId) {
        this.$router.push({
          name: 'viewSummaryReport',
          params: { id: reportId }
        })
      },
      isDdsExporterLockedOutForItem(item) {
        const currentUser = this.$store.getters.getUser;
        return isDdsExporterLockedOutByPayment(item, currentUser?.id);
      },
      navigateReportView(item) {
        if (this.isDdsExporter && this.isDdsExporterLockedOutForItem(item)) {
          this.$toast?.error?.(this.$t('dueDiligence.exporterLockedOutByPayment'));
          return;
        }
        if (this.isDdsExporter) {
          this.redirectToExporterSummary(item.id)
          return
        }
        if (item.status == 'Pending') {
          this.$router.push({ name: 'createDueDiligenceReports', params: { id: item.id, show: 'show' } })
        }else if (item.status.toLowerCase() == 'under review') {
          this.$router.push({ name: 'createDueDiligenceReports', params: { id: item.id, show: 'show' } })
        }else if(item.status.toLowerCase()  == 'ready to proceed')  {
          const tabd  = JSON.parse(localStorage.getItem('DDS_TAB_DATA'))
          const activeTb =  tabd ? (tabd.activeTab == 2) ? 3 : 4 : 3
          this.$store.dispatch('SET_DDS_TAB', {
            activeTab:activeTb 
          }).then(() => {
            this.$router.push({ name: 'createDueDiligenceReports', params: { id: item.id, show: 'show' } })
          })
        }
         else if (item.status == 'Non-Compliant') {
          const finalReportTab = 5 + (item?.diligenceReportAssessment?.length || 0)
          this.$store.dispatch('SET_DDS_TAB', {
            activeTab: finalReportTab
          }).then(() => {
            this.$router.push({ name: 'createDueDiligenceReports', params: { id: item.id, show: 'non-complaint' } })
          })
        } else if (item.status == 'Compliant') {
          const finalReportTab = 5 + (item?.diligenceReportAssessment?.length || 0)
          
          this.$store.dispatch('SET_DDS_TAB', {
            activeTab: finalReportTab
          }).then(() => {
            this.$router.push({ name: 'createDueDiligenceReports', params: { id: item.id, show: 'complaint' } })
          })
        }
      },
      async getEudrSettings() {
          try {
              const { data } = await DeforestationService.getEudrSettings();
              this.eudrSettings = data.eudrSetting;
          } catch (err) {
              this.$notify({
                  text: this.$t('deforestation.failedToFetchSettings'),
                  type: 'error',
                  duration: 10000,
              })
          }
      },
      getConvertedMass(value){
        return this.eudrSettings && UnitService.fromBase.weight(this.eudrSettings.product_mass_unit, value)
      },
      closeFilter() {
        this.showFilters = false;
      },
      clearFilters() {
        this.producerModel = '';
        this.placeStatus = '';
        this.placeCountry = '';
      },
    },
  
    mixins: [tableCustomizationMixin, loadingMixin, download, getPermittedActions, DateMixin, RoleMixin],
  };
  </script>
  
  <style scoped>
  ::v-deep .v-data-table__wrapper{
    margin-top: -16px !important;
  }
  .blue-button {
    background-color: #d0e6fe !important;
    /* Green background */
    border: 2px solid #002287 !important;
    /* Red border */
    color: #002287 !important;
  }
  
  .gray-button {
    background-color: #e8e8e8 !important;
    /* Green background */
    border: 2px solid #000000 !important;
    /* Red border */
    color: #000000 !important;
  }
  
  /* .orange-button {
    background-color: rgba(181, 109, 1, 0.2) !important;
    border: 2px solid #B56D01 !important;
    color: #B56D01 !important;
  } */
  
  .card-title {
    font-weight: 600;
    font-size: 18px;
    color: #1e1e1e;
  }
  
  .card-sub-title {
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 16px;
    color: #787878;
  }
  
  .card-price {
    font-weight: 600;
    font-size: 60px;
    color: #2e2f31;
  }
  
  .card-sub-price {
    margin-left: 10px;
    font-weight: 600;
    font-size: 16px;
    color: #2e2f31;
  }
  
  .usage-limit-card {
    padding: 10px;
    height: auto;
    width: auto;
  }
  
  @media only screen and (max-width: 600px) {
    .usage-limit-card {
      min-height: 55vh !important;
    }
  }
  
  @media only screen and (min-width: 600px) and (max-width: 1080px) {
    .usage-limit-card {
      min-height: 30vh !important;
    }
  }
  
  @media only screen and (min-width: 1080px) {
    .usage-limit-card {
      min-height: 20vh !important;
    }
  }
  
  .radial-bar-chart {
    margin-top: -20px;
  }
  
  .heading-title {
    font-weight: 600;
    font-size: 22px;
    color: #1e1e1e;
  }
  
  .main-price {
    display: flex;
    align-items: center;
    margin-top: 25px;
  }
  
  .card-content {
    text-align: center;
  }
  
  .green-button {
    background-color: #c1ffe7 !important;
    /* Green background */
    border: 2px solid #489e16 !important;
    /* Red border */
    color: #489e16 !important;
  }
  
  .green-shadow {
    color: #00bd73 !important;
  }
  
  .red-button {
    background-color: #fdebeb !important;
    /* Green background */
    border: 2px solid #da3d3d !important;
    /* Red border */
    color: #da3d3d !important;
  }
  
  .orange-button {
    background-color: #fff7ec !important;
    /* Green background */
    border: 2px solid #ffa826 !important;
    /* Red border */
    color: #ffa826 !important;
  }
  
  ::v-deep .v-data-table-header span {
    text-transform: none !important;
  }

  ::v-deep .v-data-table-header__icon.v-icon.v-icon.v-icon {
    color: white !important;
    opacity: 1 !important;
  }
  ::v-deep .my-custom-dialog {
    position: absolute;
    top: 0;
    min-height: 100%;
    right: 0;
    margin-right: 0px;
    margin-top: 0px;
  }

  ::v-deep .sticky-bottom-alert{
    width: 74% !important;
    position:fixed;
    left: 20%;
    bottom: 0;
    opacity: 0.95;
    z-index: 999;

  }

  .no-pointer {
    pointer-events: none;
    cursor: default;
  }

  ::v-deep .non-clickable {
    pointer-events: none;
    cursor: default;
  }

  /* Responsive improvements for small desktop screens */
  @media (max-width: 1280px) {
    .usage-limit-card {
      min-height: 20vh !important;
      padding: 5px !important;
      width: 95% !important;
    }
    .card-title, .heading-title {
      font-size: 16px !important;
    }
    .card-price {
      font-size: 36px !important;
    }
    .main-price {
      margin-top: 10px !important;
    }
    .v-card {
      padding: 10px !important;
    }
    .v-data-table th, .v-data-table td {
      font-size: 13px !important;
      padding: 6px 4px !important;
      min-width: 80px !important;
      max-width: 180px !important;
      word-break: break-word;
    }
    .v-data-table {
      font-size: 13px !important;
    }
    .v-row, .v-col {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .v-card[style*="width: 300px"] {
      width: 90vw !important;
      min-width: 180px !important;
      max-width: 300px !important;
      padding: 20px !important;
      height: auto !important;
    }
    .d-flex[style*="margin-top: 60px;"] {
      margin-top: 20px !important;
    }
  }

  @media (max-width: 1024px) {
    .v-row {
      flex-direction: column !important;
    }
    .v-col, .v-card {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
    }
    .v-data-table th, .v-data-table td {
      font-size: 12px !important;
      padding: 4px 2px !important;
      min-width: 60px !important;
      max-width: 120px !important;
    }
    .heading-title {
      font-size: 15px !important;
    }
  }

    /* Responsive, compact controls bar for table filters/actions */
  .table-controls-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: nowrap; /* Prevent wrapping unless absolutely necessary */
    gap: 12px;
    margin-bottom: 12px;
  }
  .controls-left {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex: 1 1 auto;
    min-width: 0;
  }
  .controls-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
    min-width: 0;
    padding-bottom: 22px;
  }
  .download-history{
    padding-bottom: 22px;
  }
  .control {
    min-width: 120px;
    max-width: 220px;
    flex: 1 1 160px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .pagination-label {
    font-size: 14px;
    margin-right: 0.5rem;
    white-space: nowrap;
  }
  @media (max-width: 1100px) {
    .table-controls-bar {
      flex-wrap: wrap;
    }
    .controls-left, .controls-right {
      flex-wrap: wrap;
      gap: 8px;
    }
    .control {
      max-width: 160px;
      flex: 1 1 120px;
    }
  }
  @media (max-width: 600px) {
    .v-card {
      padding: 12px !important;
      font-size: 15px;
    }
    .v-card strong {
      font-size: 15px;
    }
  }
  @media (max-width: 400px) {
    .v-card {
      font-size: 13px;
    }
  }
  .dashboard-card {
    min-height: 180px;
    padding: 32px 12px;
    width: 100%;
    max-width: 340px;
  }
  @media (max-width: 900px) {
    .dashboard-card {
      min-height: 140px;
      padding: 20px 8px;
      max-width: 100%;
    }
  }
  .report-card {
    border-radius: 18px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.07);
    font-size: 1rem;
  }
  .report-title {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .report-row:last-child {
    border-bottom: none;
  }
  @media (max-width: 600px) {
    .report-card {
      padding: 12px !important;
      font-size: 15px;
    }
    .report-title {
      font-size: 1.1rem;
    }
  }

  /* Mobile Controls and Pagination Styles */
  .mobile-controls-bar {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
  }

  .mobile-controls-left {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-search {
    width: 100%;
  }

  .mobile-filter {
    width: 100%;
  }

  .mobile-pagination {
    padding: 16px 0;
    border-top: 1px solid #e0e0e0;
  }

  .mobile-pagination-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
  }

  .mobile-pagination-controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Responsive adjustments for mobile */
  @media (max-width: 480px) {
    .mobile-controls-bar {
      gap: 8px;
    }
    
    .mobile-controls-left {
      gap: 8px;
    }
    
    .mobile-pagination {
      padding: 12px 0;
    }
    
    .mobile-pagination-label {
      font-size: 13px;
    }
  }

.status-legend-inline {
  font-size: 14px;
  flex-wrap: wrap;
}
.legend-label {
  color: #222;
}
.legend-item {
  white-space: nowrap;
  font-size: 14px;
}
.status-legend-section {
  background: #f8f9fa;
  border-radius: 10px;
  flex-wrap: wrap;
  font-size: 15px;
}
.legend-title {
  color: #222;
}
.legend-item {
  white-space: nowrap;
  font-size: 15px;
}
  </style>
